__turbopack_context__.v({
  "menu": "dropdown-menu-module-scss-module__oSUnxq__menu",
  "menu-item": "dropdown-menu-module-scss-module__oSUnxq__menu-item",
  "menu-item--selected": "dropdown-menu-module-scss-module__oSUnxq__menu-item--selected",
  "menu-item--with-separator-after": "dropdown-menu-module-scss-module__oSUnxq__menu-item--with-separator-after",
  "menu-item--with-separator-before": "dropdown-menu-module-scss-module__oSUnxq__menu-item--with-separator-before",
  "menu-item-icon": "dropdown-menu-module-scss-module__oSUnxq__menu-item-icon",
  "popover": "dropdown-menu-module-scss-module__oSUnxq__popover",
  "slide-in": "dropdown-menu-module-scss-module__oSUnxq__slide-in",
  "slide-out": "dropdown-menu-module-scss-module__oSUnxq__slide-out",
  "trigger": "dropdown-menu-module-scss-module__oSUnxq__trigger",
  "trigger--selected": "dropdown-menu-module-scss-module__oSUnxq__trigger--selected",
  "trigger__more-icon": "dropdown-menu-module-scss-module__oSUnxq__trigger__more-icon",
  "trigger__more-icon-wrapper": "dropdown-menu-module-scss-module__oSUnxq__trigger__more-icon-wrapper",
  "wrapper": "dropdown-menu-module-scss-module__oSUnxq__wrapper",
});
